import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { bridgeTypes } from '../data/mockData';
import { Check } from 'phosphor-react';

export const TrussSelector = ({ selected, onSelect }) => {
  return (
    <div className="space-y-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-slate-100 mb-2">Select Truss Type</h3>
        <p className="text-sm text-slate-400">Choose the structural design for your bridge</p>
      </div>

      <div className="space-y-3">
        {bridgeTypes.map((bridge) => (
          <Card 
            key={bridge.id}
            className={`cursor-pointer transition-all duration-200 hover:shadow-lg ${
              selected === bridge.id 
                ? 'ring-2 ring-blue-500 bg-slate-700 border-blue-500' 
                : 'border-slate-600 bg-slate-750 hover:border-blue-400 hover:bg-slate-700'
            }`}
            onClick={() => onSelect(bridge.id)}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div 
                    className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white font-bold text-lg"
                  >
                    {bridge.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-200">{bridge.name}</h4>
                    <p className="text-sm text-slate-400">{bridge.description}</p>
                  </div>
                </div>
                {selected === bridge.id && (
                  <div className="flex items-center gap-2">
                    <Badge className="bg-blue-600 text-white">Selected</Badge>
                    <Check className="w-5 h-5 text-blue-400" />
                  </div>
                )}
              </div>
              
              {/* Truss Preview */}
              <div className="bg-slate-600 rounded-lg p-3 mt-2">
                <div className="text-center">
                  <div className="text-2xl text-blue-400 mb-1">
                    {bridge.id === 'warren' && '△▽△▽△'}
                    {bridge.id === 'pratt' && '△|△|△'}
                    {bridge.id === 'long' && '△▽△▽△▽△'}
                    {bridge.id === 'modular' && '□□□□'}
                  </div>
                  <p className="text-xs text-slate-400">Structure Pattern</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Selection Actions */}
      <div className="pt-4 border-t border-slate-600">
        <Button 
          className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          disabled={!selected}
        >
          Apply Truss Type
        </Button>
      </div>
    </div>
  );
};